import Vue from 'vue';
import Meta from 'vue-meta';
import reportData from '@/utils/reportData';
import initData from '@/utils/init-data';
import { createRouter } from './router/index-web';
import store from './store';
import webComponentPlugin from './components/basic/webPlugin';
import hippyComponentPlugin from './components/basic/hippyPlugin';
import hippyPlugins from './plugins/hippy';
import { setApp } from './utils/util';
import './assets/css/index.css';
import webComponent from './components/basic/webEntry';
// import hippyComponent from './components/basic/hippyEntry';
import config from './config';
import ImageTools from './utils/imageTool';
import CommonTools from './plugins/hippy/common';
import LoginableDiv from './components/LoginableDiv';
import jsbridge from './jsbridge/web';
import { ReportDataPlugin } from './plugins/report_data_plugin';

ReportDataPlugin.install(Vue);
Vue.reportData = reportData;
Vue.prototype.$bus = new Vue();
Vue.Jsbridge = jsbridge;
Vue.config.productionTip = false;
// 非node_module方式的插件，使用Vue.use的方式会导致服务端内存泄漏
webComponentPlugin.install(Vue);
webComponent.install(Vue);
Vue.prototype.appConfig = config;
ImageTools.install(Vue);
CommonTools.install(Vue);
hippyComponentPlugin.install(Vue);
hippyPlugins.install(Vue);
CommonTools.install(Vue);
// Vue.use(hippyComponent);
Vue.component(LoginableDiv.name, LoginableDiv);

Vue.registerElementOnce = function registerElementOnce(...args) {
  try {
    Vue.registerElement(...args);
  } catch (e) {
    // nothing to do.
  }
};

const App = require('./App.vue').default;

const originData = App.data;
App.data = function initAppData() {
  const data = typeof originData === 'function' ? originData() : originData;
  return {
    ...initData,
    ...data,
  };
};

// eslint-disable-next-line import/prefer-default-export
export const createApp = function createApp(ssrContext) {
  Vue.use(Meta, {
    keyName: 'head',
    attribute: 'data-n-head',
    ssrAttribute: 'data-n-head-ssr',
    tagIDKeyName: 'headId',
  });

  const router = createRouter();
  const app = new Vue({
    // the root instance simply renders the App component.
    router,
    store,
    head: {
      // 目前只支持Object格式
      __dangerouslyDisableSanitizers: ['script'],
    },
    ssrContext,
    ...App,
  });
  setApp(app);

  return { app, router, store };
};
